



































import { Vue, Component, Prop } from 'vue-property-decorator';

import { colorDefaultData } from '@/componentsV2/molecules/ColorPicker/colorsDictionary';

@Component({})
export default class BrandedCoinPreview extends Vue {
  @Prop({ default: '380' }) size?: string;
  @Prop({ default: colorDefaultData.colorHex }) fill?: string;
}
